import herbal from '../assets/Project/herbal.jpg'
import signalist from '../assets/Project/signalist.jpg'
import investaX from '../assets/Project/investaX.jpg'
import analytics from '../assets/Project/analytics.jpg'
import resume from '../assets/Project/resume.jpg'
import learnifyX from '../assets/Project/learnifyX.jpg'
import Portfolio from '../assets/Project/Portfolio.jpg'
import Websites from '../assets/Project/Websites.jpg'
import git from '../assets/Project/git.jpg'



export const projectsData = [
    {
        id: 1,
        projectName: 'HerbEaseMarket',
        projectDesc: 'An e-commerce platform for herbal products built with HTML, CSS, JavaScript, AJAX, Django, PHP, and MySQL, offering smooth browsing, wishlist, purchasing, and secure payment features.',
        tags: ['HTML & CSS','JavaScript', 'AJAX & Django', 'PHP & MySQL'],
        code: 'https://github.com/19salonitomar/HerbEaseMarket',
        demo: 'https://github.com/19salonitomar/HerbEaseMarket',
        image: herbal
    },
    {
        id: 2,
        projectName: 'Signalist',
        projectDesc: 'AI-powered stock app with real-time tracking, alerts, insights, and admin dashboard, automation workflows, and a user-friendly interface for informed trading decisions.',
        tags: ['NextJs', 'MongoDB', 'Better-Auth', 'Inngest','Code Rabbit'],
        code: 'https://github.com/19salonitomar/WealthLens',
        demo: 'wealth-lens-mu.vercel.app',
        image: signalist
    },
    {
        id: 3,
        projectName: 'QuickAnalyzr',
        projectDesc: 'A Streamlit-based web tool that enables users to upload, explore, clean, visualize, and analyze datasets easily, making EDA and basic ML accessible without coding.',
        tags: ['Python', 'Streamlit', 'Python-Libraries', 'ML Algorithms'],
        code: 'https://github.com/19salonitomar/QuickAnalyzr',
        demo: 'https://github.com/19salonitomar/QuickAnalyzr',
        image: analytics
    },
    {
        id: 4,
        projectName: 'ResumAI',
        projectDesc: "SmartATS Resume Matcher – A Python and Streamlit tool that uses Google’s Generative AI to analyze job descriptions and suggest resume improvements.",
        tags: ['Pyhton', 'streamlit', 'PyPDF2', 'generativeai'],
        code: 'https://github.com/19salonitomar/ResumAI',
        demo: 'https://github.com/19salonitomar/ResumAI',
        image: resume
    },
    {
        id: 5,
        projectName: 'LearnifyX',
        projectDesc: 'A user-friendly online learning platform offering diverse courses, personalized learning paths, real-time progress tracking, and interactive assessments.',
        tags: ['Angular', 'HTML5', 'CSS3', 'TypeScript'],
        code: 'https://github.com/19salonitomar/LearnifyX',
        demo: 'https://learnbylearnifyx.netlify.app/',
        image: learnifyX
    },
    {
        id: 6,
        projectName: 'MyPortfolio',
        projectDesc: 'A modern, fully responsive portfolio built with React to showcase my projects, technical skills, and professional journey.Designed with a clean UI, smooth interactions, and an organized structure to present my work effectively.',
        tags: ['React.js', 'Material UI', 'React Router', 'Axios'],
        code: 'https://github.com/19salonitomar/My_Portfolio',
        demo: 'https://webfolio-live.netlify.app/',
        image: Portfolio
    },
    {
        id: 7,
        projectName: 'WebArtisan',
        projectDesc: 'A collection of clean, responsive web projects built using HTML, CSS, and JavaScript.It highlights practical front-end skills through small, interactive UI components and mini applications.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/19salonitomar/WebArtisan',
        demo: 'https://github.com/19salonitomar/WebArtisan',
        image: Websites
    },
    {
        id: 8,
        projectName: 'InvestaX',
        projectDesc: 'A full MERN stack trading platform inspired by Zerodha. Built with React, Node.js, Express, MongoDB, and deployed on AWS with Jest testing for reliability',
        tags: ['ReactJS', 'MongoDB', 'Node.js', 'Material UI & CSS'],
        code: 'https://github.com/19salonitomar/InvestaX',
        demo: 'https://github.com/19salonitomar/InvestaX',
        image: investaX
    },
    {
        id: 9,
        projectName: 'Github',
        projectDesc: 'To have look on some more of my projects do visit my Github account',
        tags: ['Projects', 'Github'],
        code: 'https://github.com/19salonitomar',
        demo: 'https://github.com/19salonitomar',
        image: git
    },
]

